import React from "react";
import { Row, Col } from "react-bootstrap";
import "./NearbyOrdersMapsSkeleton.css";

const NearbyOrdersMapsSkeleton = () => {
  return (
    <div className="container-fluid p-4">
      {/* Header Skeleton */}
      <div className="mb-4">
        <div className="h-4 w-64 bg-gray-300 rounded mb-2 skeleton-shimmer"></div>
        <div className="h-3 w-96 bg-gray-200 rounded skeleton-shimmer"></div>
      </div>

      {/* MapFilters Skeleton */}
      <div className="mb-3">
        <div className="d-flex gap-2 flex-wrap">
          {[1, 2, 3, 4].map((i) => (
            <div
              key={i}
              className="h-10 bg-gray-200 rounded skeleton-shimmer"
              style={{ width: "150px" }}
            ></div>
          ))}
        </div>
      </div>

      {/* BasePointSearch Skeleton */}
      <div className="mb-3">
        <div className="d-flex gap-2 align-items-center">
          <div
            className="h-10 bg-gray-200 rounded flex-grow-1 skeleton-shimmer"
            style={{ maxWidth: "500px" }}
          ></div>
          <div
            className="h-10 bg-gray-300 rounded skeleton-shimmer"
            style={{ width: "120px" }}
          ></div>
        </div>
      </div>

      <Row>
        {/* Panel Lateral Skeleton */}
        <Col md={4}>
          <div className="p-2 bg-light rounded shadow-sm">
            {/* Radio de búsqueda título */}
            <div className="h-5 w-32 bg-gray-300 rounded mb-2 skeleton-shimmer"></div>

            {/* Botones de radio */}
            <div className="d-flex gap-2 mb-3 flex-wrap">
              {[1, 2, 3, 4].map((i) => (
                <div
                  key={i}
                  className="h-10 bg-gray-200 rounded skeleton-shimmer"
                  style={{ width: "80px" }}
                ></div>
              ))}
            </div>

            {/* Lista de órdenes cercanas */}
            <div className="mb-2">
              <div className="h-4 w-36 bg-gray-300 rounded mb-3 skeleton-shimmer"></div>
              <div className="skeleton-orders-list">
                {[1, 2, 3, 4, 5].map((i) => (
                  <div
                    key={i}
                    className="mb-2 p-2 bg-gray-100 rounded skeleton-shimmer"
                    style={{ height: "100px" }}
                  >
                    <div className="h-4 w-24 bg-gray-300 rounded mb-2 skeleton-shimmer"></div>
                    <div className="h-3 w-full bg-gray-200 rounded mb-1 skeleton-shimmer"></div>
                    <div className="h-3 w-3/4 bg-gray-200 rounded mb-1 skeleton-shimmer"></div>
                    <div className="h-3 w-1/2 bg-gray-200 rounded skeleton-shimmer"></div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Col>

        {/* Mapa Skeleton */}
        <Col md={8}>
          <div
            className="bg-gray-200 rounded skeleton-shimmer"
            style={{ width: "100%", height: "600px", position: "relative" }}
          >
            {/* Spinner centrado sobre el mapa */}
            <div className="map-skeleton-spinner">
              <div
                className="spinner-border text-primary"
                role="status"
                style={{ width: "3rem", height: "3rem" }}
              >
                <span className="visually-hidden">Cargando mapa...</span>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default NearbyOrdersMapsSkeleton;
